import React, { useMemo } from 'react';
// import classname from 'classnames';
import {
  Logo,
} from 'lidya-common-components';
import { COMPONENTS } from '../../common/webSiteLanguages';
import {
  getLinkByComponentName,
} from '../../../hooks/useNavigationLinks';
import { useGlobalData } from '../../../providers/globalDataProvider/globalDataProvider.useGlobalData';
import { ContextLink } from '../../common/contextLink';

export const useHomeLogo = (customLinks) => {
  const { country, language } = useGlobalData();
  const link = getLinkByComponentName({
    componentName: COMPONENTS.HOME,
    country,
  });
  const slug = link[`slug_${language}`];
  const { new_tab: newTab } = link;
  const HomeLogo = useMemo(() => (
    <ContextLink
      id={`HomeLink${slug}`}
      to={slug}
      className="m-navigation__linkLogo"
      ariaLabel={slug}
      target={newTab ? '_blank' : undefined}
    >
      <Logo
        className="m-navigation__logo"
      />
    </ContextLink>
  ), [newTab, slug]);

  if (customLinks) return <a href={`#${slug}`} label={slug} className="m-navigation__linkLogo" area-label={slug}><Logo className="m-navigation__logo" /></a>;
  return HomeLogo;
};

export default useHomeLogo;
